<template>
    <div class="download">
        <div class="banner">
                <el-carousel height="330px" arrow="always" >
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <img v-if="languageType == 0" @click="toProductdetail(item.category,item.productName)" :src="item.picUrl"/>
                        <img v-else @click="toProductdetail(item.category,item.productName)" :src="item.enPicUrl"/>
                    </el-carousel-item>
                </el-carousel>
        </div>
        <div class="head_title">
            <ul>
                <li>
                    <p>下载中心</p>
                    <span>Download Center</span>
                </li>
            </ul>
            <div class="local">
                <p v-if="languageType == 0">当前位置：首页 > 下载中心</p>
                <p v-else>Location: Home > Download Center</p>
            </div>
        </div>
        <div class="download_list">
            <div class="list">
                <ul>
                    <li v-for="(item,index) in downloadList" :key="index" :class="currentIndex == index?'active':''"  @mouseenter="item_enter(index)" @mouseleave="item_leave(index)">
                        <div class="text">
                            <span>{{ item.name }}</span>
                        </div>
                        <div class="check_down" @click="downloading(item.url)">
                            <span v-if="languageType == 0">立即下载</span>
                            <span v-else>Download</span>
                        </div>
                    </li>
                </ul>
                <div class="nodata" v-if="downloadList.length == 0">
                    <p>暂无内容</p>
                </div>
                <div class="page">
                    <el-pagination
                    background
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="totalCount">
                    </el-pagination>
                    <div class="mount">
                        <span v-if="languageType == 0">共 {{ totalPage }} 页</span>
                        <span v-else>Total {{totalPage}} Page</span>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType'],
    data () {
        return {
            currentIndex:100,
            pageIndex: 1,
            pageSize: 5,
            totalPage: 0,
            totalCount:0,
            bannerList:[],
            downloadList:[]
        }
    },
    created () {
        // this.languageType = sessionStorage.getItem('languageType')
        this.$emit('changeIndex',4)
        this.getDataList ()
        this.getBannerList()
    },
    watch:{
        'languageType':function(a,b) {
            if(a != b){
                this.getBannerList()
            }
        }

    },
    filters:{
    },
    methods:{
        getBannerList () {
            this.$http({
                url: this.$http.adornUrl('/web/banner/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '999',
                    'type':5,
                     'productId':'',
                    'client':''
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    let arr = []
                    data.page.list.forEach( item => {
                        if(item.client == 1){
                            if(this.languageType == 0 && item.picUrl){
                                arr.push(item)
                            }else if(this.languageType == 1 && item.enPicUrl){
                                 arr.push(item)
                            }
                        }
                    })
                    this.bannerList = arr
                } else {
                    this.bannerList = []
                }
            })
        },
        getDataList () {
          this.$http({
                url: this.$http.adornUrl('/web/download/list'),
                method: 'post',
                data: {
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.downloadList = data.page.list
                    this.totalCount = data.page.totalCount
                    this.totalPage = data.page.totalPage
                } else {
                    this.downloadList = []
                    this.totalCount = 0
                }
            })  
        },
        downloading (val) {
            window.location.href = val
        },
        item_enter (index) {

            this.currentIndex = index
        },
        item_leave () {
            this.currentIndex = 100
        },
        toProductdetail (id,name) {
            this.$router.push({ name: 'productdetail',query:{key:JSON.stringify(name),id:JSON.stringify(id)}}),
            this.$emit('changeIndex',5)
        }
    }
}
</script>

<style lang="less" scoped>
    .download {
        max-width: 1920px;
        .banner {
            height: 330px;
            img {
                height: 330px;
                cursor: pointer;
            }
        }
        .head_title {
            width: 1170px;
            margin: 0 auto;
            overflow: hidden;
            height: 76px;
            ul {
                margin-top: 20px;
                float: left;
                li {
                        width: 110px;
                        padding: 0 40px;
                        cursor: pointer;
                        border-left: 1px solid #b2b2b2;
                        border-right: 1px solid #b2b2b2;
                        position: relative;
                        p {
                            color: #e21711;
                            font-size: 20px;
                        }
                        span {
                            color: #e21711;
                            font-size: 14px;
                        }

                    }
            }
            .local {
                float: right;
                p {
                    color: #606060;
                    font-size: 16px;
                    margin: 31px 0;
                }
            }
        }
        .download_list {
            // height: 650px;
            position: relative;
            background-color: #f4f4f4;
            overflow: hidden;
            .list {
                width: 1170px;
                margin: 0 auto;
                height: 561px;
                background-color: #dbdbdb;
                margin-top: 20px;
                border-top: 1px solid #dbdbdb;
                margin-bottom: 70px;
                ul {
                    li {
                        width: 1014px;
                        height: 65px;
                        overflow: hidden;
                        position: relative;
                        background-color: #ffffff;
                        margin: 0 auto;
                        margin-bottom: 20px;
                        cursor: pointer;
                        .text {
                            margin-left: 83px;
                            line-height: 65px;
                            width:760px;
                            text-align: left;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                            span {
                                font-size: 14px;
                                color: #000000;
                            }
                        }
                        .check_down {
                            position: absolute;
                            top: 1px;
                            right: 1px;
                            width: 130px;
                            height: 61px;
                            border: 1px solid #e21711;
                            line-height: 61px;
                            text-align: center;
                            z-index: 100;
                            // margin-top: 1px;
                            // margin-right: 1px;
                            span {
                                color: #e21711;
                                font-size: 20px;
                            }
                        }
                        // &.active {
                        // transform: scale(1.03);
                        // box-shadow:-6px 0 3px rgba(194, 194, 194, 0.3),6px 0 3px rgba(194, 194, 194, 0.3),
                        //     0 -6px 3px rgba(194, 194, 194, 0.3), 0 6px 3px rgba(194, 194, 194, 0.3);
                        //   .check_down {
                        //       background-color: #e21711;
                        //       span {
                        //           color: #ffffff;
                        //       }
                        //   }  
                            // }
                    }
                    li::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 63px;
                        height: 63px;
                        background-color: #999999;
                        left: 1px;
                        top: 1px;
                    }
                    li:first-child {
                        margin-top: 40px;
                    }
                    li:hover {
                        // transform: scale(1.03);
                        box-shadow:-6px 0 3px rgba(194, 194, 194, 0.3),6px 0 3px rgba(156, 96, 96, 0.3),
                            0 -6px 3px rgba(194, 194, 194, 0.3), 0 6px 3px rgba(194, 194, 194, 0.3);
                          .check_down {
                              background-color: #e21711;
                              span {
                                  color: #ffffff;
                              }
                          }  
                    }
                    
                }
                .nodata {
                    height: 300px;
                    p {
                        color: #606060;
                        letter-spacing: 8px;
                        padding-top: 180px;
                    }
                }
                .page {
                    margin-top: 60px;
                    line-height: 30px;
                    padding-bottom: 60px;
                .mount {
                    display: inline-block;
                    span {
                        font-size: 15px;
                        color: #606060;
                    }
                }

            }
            }
        }
        .download_list::before {
            content: '';
            display: block;
            position: absolute;
            top: -180px;
            left: -440px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/long.png)no-repeat center center;
            transform: scale(0.8)
        }
        .download_list::after {
            content: '';
            display: block;
            position: absolute;
            right: -275px;
            bottom: -160px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/tu.png)no-repeat center center;
            transform: scale(0.8)
        }
    }
</style>
<style lang="less">
    .page {
        .el-pagination {
            display: inline-block;
        }
        .el-pagination.is-background .el-pager li:not(.disabled).active{
                background-color:#e21711
        }
        .el-pagination.is-background .el-pager li {
            border: 1px solid #e21711;
            color: #e21711
        }
        .el-pagination.is-background .el-pager li:not(.active):hover{
            color: #e21711;
        }
        .el-pagination.is-background .btn-prev {
            border: 1px solid #e21711;
        }
        .el-icon-arrow-left:before {
            color: #e21711;
        }
         .el-pagination.is-background .btn-next {
            border: 1px solid #e21711;
        }
        .el-icon-arrow-right:before {
            color: #e21711;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/download.vue